import { render, staticRenderFns } from "./user-navigation.vue?vue&type=template&id=6239f5d8&scoped=true&lang=pug&"
import script from "./user-navigation.vue?vue&type=script&lang=js&"
export * from "./user-navigation.vue?vue&type=script&lang=js&"
import style0 from "./user-navigation.vue?vue&type=style&index=0&id=6239f5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239f5d8",
  null
  
)

component.options.__file = "user-navigation.vue"
export default component.exports